import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

import AppTemplate from '@/app/shared/ui/templates/AppTemplate.vue';
import Table from '@/app/shared/components/Table.vue';
import ServiceOrderRepository from '@/app/service-order/infrastructure/persistence/ServiceOrderRepository';
import StatusMapper from '@/app/shared/application/StatusMapper';
import useNotificationRepository from '@/app/shared/infrastructure/persistence/notification-repository';
import { inject, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceOrderList',
  setup(__props) {

const notificationRepository = useNotificationRepository();
const repository = inject('serviceOrderRepository') as ServiceOrderRepository;
const serviceOrders = ref<any[]>([]);

async function loadData() {
    serviceOrders.value = await repository.getAll();
}

onMounted(loadData);

const columns = [
    {title: 'ID', key: 'id'},
    {title: 'Título', key: 'title'},
    {title: 'Status', key: 'status'},
];

const deleteServiceOrder = async (serviceOrder: any) => {
    if (confirm(`Deseja excluir a ordem de serviço ${serviceOrder.id}?`)) {
        await repository.remove(serviceOrder.id);

        notificationRepository.insert({
            id: Date.now().toString(),
            type: 'success',
            message: 'Ordem de serviço removida com sucesso',
        });

        loadData();
    }
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(AppTemplate, null, {
    default: _withCtx(() => [
      _createVNode(Table, {
        items: serviceOrders.value,
        title: "Ordens de serviço",
        "key-filter": "title",
        columns: columns
      }, {
        "append-title": _withCtx(() => [
          _createVNode(_component_v_btn, {
            to: "/ordens-de-servico/cadastrar",
            "prepend-icon": "mdi:mdi-content-save",
            color: "primary",
            variant: "flat"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cadastrar")
            ]),
            _: 1
          })
        ]),
        "value-content": _withCtx(({ item, colunm }) => [
          (colunm.key === 'status')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_unref(StatusMapper).map(item.status)), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        "edit-button": _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            to: `/ordens-de-servico/editar/${item.id}`,
            icon: "",
            size: "x-small",
            class: "mr-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi:mdi-pencil")
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        "remove-button": _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            onClick: ($event: any) => (deleteServiceOrder(item)),
            icon: "",
            size: "x-small"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi:mdi-delete")
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})